<template>
    <div id="layout" class="docker__item">
      <van-cell is-link @click="showPopup">
        <van-icon name="newspaper-o" size=".6rem"/>
        <span class="docker__item__text">目录</span>
      </van-cell>
      <van-popup
        class="docker__item"
        v-model:show="show"
        position="left"
        :style="{height:'85%',width: '70% ', padding:'0.1rem 0'}"
        >
          <van-collapse v-model="activeName" accordion @change="onChange">
            <van-collapse-item
              class="docker__item__layout"
              v-for="(item, index) in layoutList"
              :key="index"
              :title="item.pageName"
              :name="index+1"
            >
            <div
              class="docker__page"
              v-for="(news, newsIndex) in directoryData"
              :key="newsIndex"
            >
            <router-link
              :to="`/content/${news.id}/${news.accessName}/${item.id}/${item.pageDate}`"
            >
              <div
                class="docker__page__title"
                @click.stop="addPageListData({
                  'index': index,
                  'id': item.id,
                  'pageNum': item.pageNum,
                  'pageName': item.pageName,
                  'accessName': item.accessName,
                  'pagePicFile': item.pagePicFile,
                  'newsArea': item.newsArea,
                  'outfilePath': item.outfilePath
                })"
              >
              {{news.title}}
              </div>
            </router-link>
            </div>
            </van-collapse-item>
          </van-collapse>
      </van-popup>
    </div>
</template>
<script>
import { ref, watch, computed } from 'vue'
import { useStore } from 'vuex'
import { get } from '../../utils/request'
export default {
  name: 'LayoutPeriodical',
  props: {
    pageDate: String
  },
  setup (props, { emit }) {
    // 应该用reactive，但是没数据，用ref就有数据
    const activeName = ref('')
    const layoutList = ref([])
    const directoryData = ref([])
    const emitPageList = ref({})
    const layoutListId = ref([])
    const newId = ref()
    const defaultList = ref([])
    const allNewsList = ref()
    const swiperIndex = ref(0)
    const layoutDate = ref()
    const layoutAllList = ref()
    const store = useStore()
    const newspaper = computed(() => store.state.newspaper)
    const newSwiperIndex = computed(() => store.state.swiperIndex)
    const pageDate = computed(() => store.state.pageDate)
    // document.title = '版面'
    const getAllPageList = async () => {
      if (pageDate.value !== '') {
        layoutDate.value = pageDate.value
      } else {
        layoutDate.value = props.pageDate
      }
      if (layoutDate.value !== undefined) {
        const url = `tablePageController/getTablePageList?pageDate=${layoutDate.value}&accessName=${newspaper.value}`
        const result = await get(url)
        if (result.code === 200 && result.list.length) {
          layoutAllList.value = result.list
          store.dispatch('addAllPageListData', layoutAllList.value)
          defaultList.value = {
            index: 0,
            id: layoutList.value[0].id,
            accessName: layoutList.value[0].accessName,
            pagePicFile: layoutList.value[0].pagePicFile,
            newsArea: layoutList.value[0].newsArea,
            outfilePath: layoutList.value[0].outfilePath
          }
          store.dispatch('getDefaultList', defaultList.value)
          layoutList.value.map((item, index) => {
            layoutListId.value.push(item.id)
          })
          layoutListId.value.map((item, index) => {
            if (newSwiperIndex.value === index) {
              getDirectoryList(item)
            }
          })
        }
      }
    }
    getAllPageList()
    const getLayoutList = async () => {
      if (pageDate.value !== '') {
        layoutDate.value = pageDate.value
      } else {
        layoutDate.value = props.pageDate
      }
      if (layoutDate.value !== undefined) {
        // const url = `tablePageController/getTablePageList?pageDate=2021-12-29&accessName=${accessName}`
        // const url = `tablePageController/getTablePageList?pageDate=${pageDate.value}&accessName=${newspaper.value}`
        const url = `tablePageController/getPeriodicalTablePageList?pageDate=${layoutDate.value}&accessName=${newspaper.value}`
        const result = await get(url)
        if (result.code === 200 && result.list.length) {
          layoutList.value = result.list
          // debugger
          // store.dispatch('addAllPageListData', layoutList.value)
          // defaultList.value = {
          //   index: 0,
          //   id: layoutList.value[0].id,
          //   accessName: layoutList.value[0].accessName,
          //   pagePicFile: layoutList.value[0].pagePicFile,
          //   newsArea: layoutList.value[0].newsArea,
          //   outfilePath: layoutList.value[0].outfilePath
          // }
          // store.dispatch('getDefaultList', defaultList.value)
          // layoutList.value.map((item, index) => {
          //   layoutListId.value.push(item.id)
          // })
          // layoutListId.value.map((item, index) => {
          //   if (newSwiperIndex.value === index) {
          //     getDirectoryList(item)
          //   }
          // })
        }
      }
    }
    // getLayoutList()
    const getNewsList = async () => {
      if (pageDate.value !== '') {
        layoutDate.value = pageDate.value
      } else {
        layoutDate.value = props.pageDate
      }
      const url = `tableNewsController/getTableNewsList?pageDate=${layoutDate.value}&accessName=${newspaper.value}`
      const result = await get(url)
      store.dispatch('getDirectoryList', result.list)
    }
    getNewsList()
    const getAllNewsList = async () => {
      if (pageDate.value !== '') {
        layoutDate.value = pageDate.value
      } else {
        layoutDate.value = props.pageDate
      }
      if (layoutDate.value !== undefined) {
        const url = `tableNewsController/notRemovalNewsList?pageDate=${layoutDate.value}&accessName=${newspaper.value}`
        const result = await get(url)
        allNewsList.value = result.list
        // store.dispatch('getDirectoryList', allNewsList.value)
      }
    }

    getAllNewsList()
    const getDirectoryList = async (id) => {
      if (id === undefined) {
        newId.value = defaultList.value.id
      } else {
        newId.value = id
      }
      for (let i = 0; i < layoutList.value.length; i++) {
        const index = i + 1
        if (id === index) {
          newId.value = layoutList.value[i].id
        }
      }
      const url = `/tableNewsController/getTableNewsList?ids=${newId.value}&accessName=${defaultList.value.accessName}`
      const result = await get(url)
      directoryData.value = result.list
      console.log(directoryData.value)
      // store.dispatch('getDirectoryList', directoryData.value)
    }
    const addPageListData = (list) => {
      swiperIndex.value = list.index
      store.dispatch('getSwiperIndex', swiperIndex)
      const id = list.id
      emitPageList.value = list
      store.dispatch('addPageListData', emitPageList)
      show.value = false
      getDirectoryList(id)
    }
    const pageList = computed(() => store.state.pageList)
    const onChange = (id) => {
      getDirectoryList(id)
    }
    watch(
      props.swiperIndex,
      () => {
        // debugger
        getAllNewsList()
      }
    )
    watch(() => {
      getLayoutList()
      getAllPageList()
      getAllNewsList()
      getNewsList()
    })

    const show = ref(false)

    const showPopup = () => {
      show.value = true
    }
    return {
      show,
      activeName,
      directoryData,
      showPopup,
      layoutList,
      emitPageList,
      pageList,
      addPageListData,
      onChange
    }
  }
}
</script>
<style lang="scss" scoped>
@import '../../style/variables.scss';
.docker__item {
    flex: 1;
    text-align: center;
    color: $content-fontcolor;
    &__text{
      font-size: .45rem;
      margin-left: .05rem;
      display: inline-block;

    }
    &__layout{
      text-align: left;
    }
    .docker__page{
      width: 100%;
      &__title{
        color: #999999;
        margin-top: 5px;
      }
    }
    .van-collapse-item__content{
      padding: 0;
    }
  }
</style>
